export default __webpack_public_path__ + "static/media/start.860465de.png";